import type { FaireProductEntity } from "../../entity_types/product";

export const p_9xl7ztkziw: FaireProductEntity = {
  token: "p_9xl7ztkziw",
  type: "product",
  name: "Natural Cable Beanie Baby & Kids",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/ab734f9faf28732162bb3ca7fefd20bb7b6d5c4162951fade72130d69d3d97da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/618532615b9db118feb318878d4a42fde03e7743218b6818d4d7ab2f898d696e.jpeg",
    "https://cdn.faire.com/fastly/2f53714b0c8124e844ce02a0cdce78ec67b3ea5997ad95a2f1634e72570cbb0c.jpeg",
    "https://cdn.faire.com/fastly/fefa96964e7ed7c1a3a4dee79f56e0384a6bc43dbb22b295b22102bb7ad7db63.jpeg",
    "https://cdn.faire.com/fastly/2a6e522242eeffe6cac1b5d1ddc339de480930a74359b3b884bf4177a7922938.jpeg",
    "https://cdn.faire.com/fastly/3e80442fb22064152046ba0be697f8fd1a5baea79d9a28c9f6aa7e1b09fe9045.jpeg",
  ],
  priceDollars: 17,
  description:
    "New mommy and me style! This beautifully soft cable knit is in a slouchy style with a fluffy pom pom. So cute you'll want one in every color!\n100% acrylic.\nCold handwash.\nHand-knit in China.",
  tags: [],
  msrpDollars: 34,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:11.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
